//* DEMOS - https://swiperjs.com/demos#effect-coverflow
//? EXEMPLO COVERFLOW EFFECT - https://codesandbox.io/s/kej446?file=/index.html

//? Adicionar CDN de CSS e JS no html
// Colocar essa função em "created()"
		// created() {
		//  startSwiper();
		// },
function startSwiper() {
	const addStyleSwiper = document.createElement("link");
	addStyleSwiper.id = "styleSwiper";
	addStyleSwiper.rel = "stylesheet";
	addStyleSwiper.href = "https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.min.css";
	document.head.appendChild(addStyleSwiper);
	
	const addScriptSwiper = document.createElement("script");
	addScriptSwiper.id = "scriptSwiper"
	addScriptSwiper.src = "https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js" 

	document.head.appendChild(addScriptSwiper);
}

//? Montar o componente do swiper
// Colocar essa função em "mounted()"
		// async mounted() {
		//  await	mountCoverflowSwiper();
		// },
function mountCoverflowSwiper() {
	// É necessário o setTimeout por conta do tempo de inicialização do Swiper,
	// caso não tenha o swiper dá error de não definição
	setTimeout(() => {
		// eslint-disable-next-line no-undef, no-unused-vars
		var swiper = new Swiper(".coverflowSwiper", {
			effect: "coverflow",
			grabCursor: true,
			centeredSlides: true,
			initialSlide : 3,
			speed: 1000,
			slidesPerView: "auto",
			autoplay: {
				delay: 1000,
				disableOnInteraction: true,
			},
			coverflowEffect: {
				rotate: 40,
				stretch: 0,
				depth: 100,
				modifier: 1,
				slideShadows: false,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}, 1500);
}

//! Atenção: caso queira utilizar o autoplay
//! Utilizar somente se o autoplay nas configurações não estiver funcionando
	//* Adicione um ref e um onclick no container do seu swiper
			// <div ref="refCoverflowSwiper" onclick="swiper.autoplay.start()" class="swiper coverflowSwiper">
	//* adicione esse código em "mounted()"
			// setTimeout(() => {
			// 	this.$refs.refCoverflowSwiper.click()
			// }, 1000);

//? Remover CDN de CSS e JS no html
// Colocar essa função em "beforeDestroy()"
		// beforeDestroy() {
		// 	finishSwiper();
		// },

function finishSwiper() {
	const getStyleSwiper = document.getElementById("styleSwiper");
	const getScriptSwiper = document.getElementById("scriptSwiper");

	document.head.removeChild(getStyleSwiper)
	document.head.removeChild(getScriptSwiper)
}

export {
	startSwiper,
	mountCoverflowSwiper,
	finishSwiper
};